/**
 * Maps Enalysis API unit type strings (e.g. "Temperature") to display labels.
 * Unknown values are returned trimmed for forward compatibility.
 */

/** @type {Readonly<Record<string, string>>} */
const ENALYSIS_API_UNIT_TO_DISPLAY = Object.freeze({
  Temperature: "°F",
  PressureGauge: "PSIG",
  Power: "HP",
  Percentage: "%",
  MassYear: "tonnes/day",
  Length: "Inches",
  FlowPerDayThousand: "MMSCFD",
  FlowPerDay: "MSCFD",
  Currency: "$",
  Count: "Count",
  Angle: "Degrees (°)",
});

/**
 * @param {unknown} raw
 * @returns {string}
 */
export function formatEnalysisUnitDisplay(raw) {
  if (raw == null) return "";
  const s = String(raw).trim();
  if (!s) return "";
  return ENALYSIS_API_UNIT_TO_DISPLAY[s] ?? s;
}
